// IAA configuration section
export const IAA_Vehicles = ['69497b04-df5d-485b-b220-45c13d3524c0', '7acfbb2b-a4dc-49c4-829d-dd38ab2d1f75'];
export const isArrayIncluded = (arr: string[], target: string[]) => target.every((v) => arr.includes(v));
export const areAllIAAVehicles = (target: string[]) => isArrayIncluded(IAA_Vehicles, target);
export const isIAAVehicle = (assetId: string | undefined) => IAA_Vehicles.includes(assetId ? assetId : '');
